<template>
  <div class="about-container">
    <img class="title"
         src="../assets/about-teachers-title.svg" />
    <nav>
      <router-link to="/about/teachers/elementary-school">國小</router-link>
      <router-link to="/about/teachers/junior-high-school">國中</router-link>
      <router-link to="/about/teachers/high-school">高中</router-link>
    </nav>
    <Divider class="divider" />
    <router-view />
  </div>
</template>

<script>
import Divider from "@/components/Divider.vue";

export default {
  components: {
    Divider
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  max-width: 848px;
  margin: auto;

  .title {
    display: block;
    margin: 80px auto;
    width: 135px;
  }

  nav {
    display: grid;
    grid-template-areas: ". . .";
    grid-gap: 40px;
    justify-content: center;

    a {
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 40px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }

  .divider {
    margin: 30px auto;
  }
}

@media (max-width: 1023px) {
  .title {
    margin: 20px auto !important;
  }

  nav {
    grid-gap: 25px !important;

    a {
      font-size: 12px !important;
      padding: 9px 25px !important;
    }
  }

  .divider {
    margin: 12px 5px !important;
  }
}
</style>
